module.exports = __webpack_public_path__ + "img/Certifikat1.dcf04b12.png";